import { gql } from '@apollo/client';
import { Invoice } from '@src/types/models';

export const INVOICE_LIST_ATTRIBUTES = gql`
  fragment InvoicesListAttributes on Invoice {
    id
    approvalStatus
    businessEmitter {
      id
      name
      hashId
    }
    businessRelationship {
      id
      active
      paymentTerms
      providerHashId
      bankingInfo {
        id
        bankId
        recipient
        bankName
        clabe
        bankLogoUrl
      }
      providerContacts {
        defaultContact
        contactable {
          email
        }
      }
    }
    costCenter {
      id
      name
    }
    codatSyncedAt
    createdAt
    currency
    emitterTaxpayerName
    emitterTaxpayerIdentifier
    expiryDate
    foreignTotal
    globalStatus
    invoicingDate
    mailboxStatus
    outstandingBalance
    paymentDate
    paymentStatus
    receiverCountryTaxPayerInfo {
      __typename
      ... on MexicanTaxPayerInfo {
        folio
      }
    }
    satVerified
    total
    voucherType
    factoringOffer {
      acceptedAt
    }
  }
`;

export type InvoiceListAttributes = Pick<
  Invoice,
  | 'id'
  | 'approvalStatus'
  | 'businessEmitter'
  | 'businessRelationship'
  | 'codatSyncedAt'
  | 'costCenter'
  | 'createdAt'
  | 'currency'
  | 'emitterTaxpayerName'
  | 'emitterTaxpayerIdentifier'
  | 'expiryDate'
  | 'foreignTotal'
  | 'globalStatus'
  | 'invoicingDate'
  | 'mailboxStatus'
  | 'outstandingBalance'
  | 'paymentDate'
  | 'paymentStatus'
  | 'receiverCountryTaxPayerInfo'
  | 'satVerified'
  | 'total'
  | 'voucherType'
  | 'factoringOffer'
>;
